var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('drawer',[_c('app-menu')],1),_c('div',{staticClass:"app-top"},[_c('topbar')],1),_c('div',{staticClass:"app-center"},[_c('tabs')],1),_c('div',{staticClass:"app-bottom"},[_c('dotbar')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }